import { StatoProcedura } from 'src/app/model/statoProcedura';
export class StyleUtils {
  public static getStatusClass(stato) {
    const statoUp = stato.toUpperCase();

    switch (statoUp) {
      case StatoProcedura.DATI_INVIATI_A_SAP:
      case StatoProcedura.DA_CONFERMARE:
      case StatoProcedura.DA_PRE_APPROVARE:
        return StyleProcedura.styleYellow;
      case StatoProcedura.APPROVATO:
      case StatoProcedura.APPROVATA:
      case StatoProcedura.EVASA:
        return StyleProcedura.styleGreen;
      case StatoProcedura.ERRORE:
      case StatoProcedura.ERRORE_SAP:
      case StatoProcedura.RITARDO:
      case StatoProcedura.NON_ASSEGNATO:
      case StatoProcedura.RIFIUTATO:
      case StatoProcedura.CHIUSO:
        return StyleProcedura.styleRed;
      case StatoProcedura.PRE_APPROVATO:
      case StatoProcedura.PRE_APPROVATA:
        return StyleProcedura.stylePurple;
      case StatoProcedura.NUOVA:
      case StatoProcedura.NUOVO:
        return StyleProcedura.styleOrange;
      case StatoProcedura.ELIMINATA:
      case StatoProcedura.ELIMINATO:
        return StyleProcedura.styleGray;
      case StatoProcedura.CANCELLATO:
      case StatoProcedura.REVISIONATA:
      case StatoProcedura.REVISIONATO:
      case StatoProcedura.BOZZA:
        return StyleProcedura.styleBlack;
      case StatoProcedura.LAVORATO:
      case StatoProcedura.LAVORATA:
        return StyleProcedura.styleTransparent;
      default:
        return '';
    }
  }
}

export enum StyleProcedura {
  styleGreen = 'status-green',
  styleRed = 'status-red',
  styleOrange = 'status-orange',
  styleGray = 'status-gray',
  styleYellow = 'status-yellow',
  styleTransparent = 'status-transparent',
  stylePurple = 'status-purple',
  styleBlack = 'status-black',
}

export function getBadgeStatus(element: StatoProcedura): {
  notificationStatus: BadgeStatus;
  badgeAriaLabel: string;
  badgeTitle: string;
  backgroundColor?: string;
} {
  switch (element) {
    case StatoProcedura.DA_PRE_APPROVARE:
    case StatoProcedura.DA_CONFERMARE:
    case StatoProcedura.DATI_INVIATI_A_SAP:
      return {
        notificationStatus: 'custom',
        badgeAriaLabel: element,
        badgeTitle: '',
        backgroundColor: '#d6ae01',
      };

    case StatoProcedura.APPROVATA:
    case StatoProcedura.APPROVATO:
    case StatoProcedura.EVASA:
      return {
        notificationStatus: 'confirm',
        badgeAriaLabel: element,
        badgeTitle: '',
      };
    case StatoProcedura.ERRORE:
    case StatoProcedura.ERRORE_SAP:
    case StatoProcedura.RITARDO:
    case StatoProcedura.NON_ASSEGNATO:
    case StatoProcedura.RIFIUTATO:
    case StatoProcedura.CHIUSO:
      return {
        notificationStatus: 'error',
        badgeAriaLabel: element,
        badgeTitle: '',
      };
    case StatoProcedura.NUOVA:
    case StatoProcedura.NUOVO:
    case StatoProcedura.DATI_INVIATI_A_SAP:
      return {
        notificationStatus: 'warning',
        badgeAriaLabel: element,
        badgeTitle: '',
      };

    case StatoProcedura.ELIMINATA:
    case StatoProcedura.ELIMINATO:
      return {
        notificationStatus: 'custom',
        badgeAriaLabel: element,
        badgeTitle: '',
        backgroundColor: 'var(--neutral-use-6)',
      };

    case StatoProcedura.CANCELLATO:
    case StatoProcedura.REVISIONATA:
    case StatoProcedura.REVISIONATO:
    case StatoProcedura.BOZZA:
    case StatoProcedura.IN_MODIFICA:
      return {
        notificationStatus: 'custom',
        badgeAriaLabel: element,
        badgeTitle: '',
        backgroundColor: 'var(--text-fill-primary)',
      };
    case StatoProcedura.LAVORATO:
    case StatoProcedura.LAVORATA:
      return {
        notificationStatus: 'custom',
        badgeAriaLabel: element,
        badgeTitle: '',
        backgroundColor: 'var(--charts-empty-1)',
      };
    case StatoProcedura.PRE_APPROVATO:
    case StatoProcedura.PRE_APPROVATA:
      return {
        notificationStatus: 'custom',
        badgeAriaLabel: element,
        badgeTitle: '',
        backgroundColor: 'var(--charts-violet-1)',
      };

    default:
      return {
        notificationStatus: 'neutral',
        badgeAriaLabel: element,
        badgeTitle: '',
      };
  }
}

export type BadgeStatus = 'confirm' | 'warning' | 'error' | 'info' | 'neutral' | 'custom';
